module.exports = __webpack_public_path__ + "media/general_icons/info-7d1684f6.svg";